module.exports = __webpack_public_path__ + "img/banenr-image-02.38800a76.13000d5e.png";